import { logger } from '../../../../utils/logger';

export function attachOutboundSessionDebugListeners(jsSession: {
  on: (event: string, handler: (...args: unknown[]) => void) => void;
}): void {
  jsSession.on('failed', (...args: unknown[]) => {
    const data = args[0] as { originator: string; message?: unknown; cause: string };
    logger.error('[CXone DEBUG] JsSIP session FAILED:');
    logger.error('[CXone DEBUG]   originator:', data.originator);
    logger.error('[CXone DEBUG]   cause:', data.cause);
    if (data.message) {
      logger.error('[CXone DEBUG]   message:', data.message);
    }
  });

  jsSession.on('ended', (...args: unknown[]) => {
    const data = args[0] as { originator: string; message?: unknown; cause: string };
    logger.debug('[CXone DEBUG] JsSIP session ENDED:');
    logger.debug('[CXone DEBUG]   originator:', data.originator);
    logger.debug('[CXone DEBUG]   cause:', data.cause);
  });

  jsSession.on('progress', (...args: unknown[]) => {
    logger.debug('[CXone DEBUG] JsSIP session PROGRESS:', args[0]);
  });

  jsSession.on('accepted', (...args: unknown[]) => {
    logger.debug('[CXone DEBUG] JsSIP session ACCEPTED:', args[0]);
  });

  jsSession.on('confirmed', (...args: unknown[]) => {
    logger.debug('[CXone DEBUG] JsSIP session CONFIRMED:', args[0]);
  });

  jsSession.on('peerconnection', () => {
    logger.debug('[CXone DEBUG] JsSIP session PEERCONNECTION created');
  });

  jsSession.on('connecting', (...args: unknown[]) => {
    logger.debug('[CXone DEBUG] JsSIP session CONNECTING:', args[0]);
  });

  jsSession.on('sending', (...args: unknown[]) => {
    logger.debug('[CXone DEBUG] JsSIP session SENDING:', args[0]);
  });
}

export function attachJsSessionLifecycleListeners(jsSession: {
  on: (event: string, handler: (...args: unknown[]) => void) => void;
}): void {
  const sessionEvents = [
    'peerconnection',
    'connecting',
    'sending',
    'progress',
    'accepted',
    'confirmed',
    'ended',
    'failed',
    'newDTMF',
    'newInfo',
    'hold',
    'unhold',
    'muted',
    'unmuted',
    'reinvite',
    'update',
    'refer',
    'replaces',
    'sdp',
    'icecandidate',
    'getusermediafailed',
    'peerconnection:createofferfailed',
    'peerconnection:createanswerfailed',
    'peerconnection:setlocaldescriptionfailed',
    'peerconnection:setremotedescriptionfailed',
  ];

  sessionEvents.forEach((eventName) => {
    jsSession.on(eventName, (...eventArgs: unknown[]) => {
      logger.debug(`[CXone DEBUG] JsSIP session event: ${eventName}`, eventArgs);
    });
  });
}
